import React from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, Typography, Box, Paper, Grid, Chip, IconButton,
} from '@mui/material';
import { GetApp as DownloadIcon, Delete as DeleteIcon, Add as AddIcon } from '@mui/icons-material';

const InvoicesDialog = ({
  open, onClose, invoices, onDownloadInvoice, onUpdateStatus, onDeleteInvoice, onOpenCreateInvoice,
}) => (
  <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth>
    <DialogTitle>
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Typography variant="h6">Project Invoices</Typography>
        <Button variant="contained" startIcon={<AddIcon />} onClick={onOpenCreateInvoice}>
          Create Invoice
        </Button>
      </Box>
    </DialogTitle>
    <DialogContent>
      {invoices.length === 0 ? (
        <Box textAlign="center" py={4}>
          <Typography color="text.secondary">
            No invoices created yet. Click "Create Invoice" to generate your first invoice.
          </Typography>
        </Box>
      ) : (
        <Box>
          {invoices.map((invoice) => (
            <Paper key={invoice.id} variant="outlined" sx={{ p: 2, mb: 2 }}>
              <Grid container spacing={2} alignItems="center">
                <Grid item xs={12} sm={3}>
                  <Typography variant="subtitle1" fontWeight="bold">
                    {invoice.invoice_number}
                  </Typography>
                  <Typography variant="caption" color="text.secondary">
                    {new Date(invoice.invoice_date).toLocaleDateString()}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={2}>
                  <Typography variant="h6" color="primary">
                    ${parseFloat(invoice.total).toFixed(2)}
                  </Typography>
                  <Typography variant="caption" color="text.secondary">
                    {invoice.item_count} items
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={2}>
                  <Chip
                    label={invoice.status.toUpperCase()}
                    color={
                      invoice.status === 'paid' ? 'success' :
                      invoice.status === 'sent' ? 'primary' :
                      invoice.status === 'cancelled' ? 'error' : 'default'
                    }
                    size="small"
                  />
                </Grid>
                <Grid item xs={12} sm={5}>
                  <Box display="flex" gap={1} justifyContent="flex-end">
                    <Button
                      size="small"
                      variant="outlined"
                      startIcon={<DownloadIcon />}
                      onClick={() => onDownloadInvoice(invoice.id, invoice.invoice_number)}
                    >
                      Download PDF
                    </Button>
                    {invoice.status === 'draft' && (
                      <>
                        <Button
                          size="small"
                          variant="outlined"
                          color="primary"
                          onClick={() => onUpdateStatus(invoice.id, 'sent')}
                        >
                          Mark as Sent
                        </Button>
                        <IconButton size="small" color="error" onClick={() => onDeleteInvoice(invoice.id)} aria-label={`Delete invoice ${invoice.invoice_number || ''}`}>
                          <DeleteIcon />
                        </IconButton>
                      </>
                    )}
                    {invoice.status === 'sent' && (
                      <Button
                        size="small"
                        variant="outlined"
                        color="success"
                        onClick={() => onUpdateStatus(invoice.id, 'paid')}
                      >
                        Mark as Paid
                      </Button>
                    )}
                  </Box>
                </Grid>
              </Grid>
              {invoice.notes && (
                <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                  Notes: {invoice.notes}
                </Typography>
              )}
            </Paper>
          ))}
        </Box>
      )}
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose}>Close</Button>
    </DialogActions>
  </Dialog>
);

export default InvoicesDialog;
